// extracted by mini-css-extract-plugin
module.exports = {"container":"Feature_container__1lk4i","unavailable":"Feature_unavailable__1RBcJ"};